<table class="imc-table">
    <caption>{{ source }}</caption>
    <thead>
        <tr>
            <th>IMC</th>
            <th>Classificações</th>
        </tr>
    </thead>
    <tbody>
        <tr *ngFor="let item of ranges">
            <td>{{ item.range }}</td>
            <td>{{ item.status }}</td>
        </tr>
    </tbody>
</table>
